<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    flat
    color="transparent"
    height="40"
    class="mt-0 pa-0"
  >
    <v-btn
      class="ma-2"
      elevation="3"
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="font-weight-light"
      style="width:150px;"
      v-text="$route.name"
    />

    <v-spacer />

    <dashboard-core-settings />

    <!-- <dashboard-register /> -->
  </v-app-bar>
</template>

<script>
  // Components

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      DashboardCoreSettings: () => import('./../../components/core/Settings'),

      // DashboardRegister: () => import('./../../component/User'),
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
    }),

    computed: {
      ...mapState(['drawer']),
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
    },
  }
</script>
